import * as React from 'react';
import { useAuth } from '../hooks/useAuth';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import { isCnpj } from '../utils';
import { useQuery } from '../hooks/useQuery';

const AlertaProtocoloVencido = ({ cnpj }) => {
  const { isUsuarioSebrae, isPrototocoloVencido } = useAuth();
  const { listarFornecedores } = useQuery();
  const [vencido, setVencido] = React.useState(false);

  const getfornecedor = async () => {
    const newTerm = isCnpj(cnpj) ? cnpj.replace(/[^a-zA-Z0-9]/g, '') : cnpj;

    const result = await listarFornecedores(newTerm);
    if (result && result.data && result.data.data) {
      const arr = result.data.data.map((item) => ({
        ...item,
        cnpj_sem_pontos: item.cnpj_fornec.replace(/[^a-zA-Z0-9]/g, ''),
      }));

      const fornecedor = arr.filter(
        (item) => cnpj.replace(/[^a-zA-Z0-9]/g, '') === item.cnpj_sem_pontos,
      );

      if (fornecedor.length) {
        if (fornecedor[0].flg_prot_venc === 'Sim') {
          setVencido(true);
        } else {
          setVencido(false);
        }
      }
    }
  };

  React.useEffect(() => {
    if (cnpj) {
      getfornecedor();
    }
  }, [cnpj]);

  return (
    <>
      {isPrototocoloVencido || vencido ? (
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert severity="error">
            {isUsuarioSebrae
              ? 'Existe uma pendência no cadastro (protocolo) do fornecedor selecionado. Realize a adequação no cadastro do fornecedor para enviar novas notas fiscais'
              : 'Atenção fornecedor! Seu cadastro está vencido, faça a renovação. Dúvidas? Entre em contato pelo telefone (31) 3379-9643, opção 3, ou pelo e-mail cadf@sebraemg.com.br.'}
          </Alert>
        </Stack>
      ) : null}
    </>
  );
};

export default AlertaProtocoloVencido;
